import React from 'react';

class LinkIcon extends React.Component {

    render() {
        const divStyle = {
            display: 'none',
        };

        const iconStyle = {
            enableBackground:' new 0 0 100 100'
        };

        return (

            <svg className="outbound_link" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 100 125" style={iconStyle} xmlSpace="preserve">
                <g><path d="M48.2,68.6l-6.5,6.5c-2,2-4.7,3.1-7.5,3.1c-2.8,0-5.5-1.1-7.5-3.1l-2.8-2.8c-2-2-3.1-4.7-3.1-7.5s1.1-5.5,3.1-7.5   l11.7-11.7c2-2,4.7-3.1,7.5-3.1c2.8,0,5.5,1.1,7.5,3.1l3.2,3.2c2,2,5.1,2,7.1,0c2-2,2-5.1,0-7.1l-3.2-3.2c-3.9-3.9-9.1-6-14.5-6   s-10.7,2.1-14.5,6L16.8,50.3c-3.9,3.9-6,9.1-6,14.5s2.1,10.7,6,14.5l2.8,2.8c3.9,3.9,9.1,6,14.5,6s10.7-2.1,14.5-6l6.5-6.5   c2-2,2-5.1,0-7.1C53.3,66.7,50.2,66.7,48.2,68.6z"/>
                <path d="M80.2,16c-3.9-3.9-9.1-6-14.5-6S55,12.1,51.1,16l-5.7,5.7c-2,2-2,5.1,0,7.1c2,2,5.1,2,7.1,0l5.7-5.7c2-2,4.7-3.1,7.5-3.1   c2.8,0,5.5,1.1,7.5,3.1l2.8,2.8c2,2,3.1,4.7,3.1,7.5S78,38.9,76,40.9L65,51.8c-2,2-4.7,3.1-7.5,3.1c-2.8,0-5.5-1.1-7.5-3.1   l-2.5-2.5c-2-2-5.1-2-7.1,0c-2,2-2,5.1,0,7.1l2.5,2.5c3.9,3.9,9.1,6,14.5,6c5.5,0,10.7-2.1,14.5-6l10.9-10.9c3.9-3.9,6-9.1,6-14.5   s-2.1-10.7-6-14.5L80.2,16z"/>
                </g>
                <text style={divStyle} x="0" y="115" fill="#000000">Created by Viktor Vorobyev</text>
                <text style={divStyle} x="0" y="120" fill="#000000">from the Noun Project</text>
            </svg>
        )
    }
}

export default LinkIcon;


